import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type StoreBaseReturn } from '@shared/api';

interface UseSubmitManualApplicationStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  submitManualApplication: (manualApplicationId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useSubmitManualApplicationStore = create<UseSubmitManualApplicationStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  submitManualApplication: async (manualApplicationId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.submitManualApplication(manualApplicationId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
